import { Delete } from '@mui/icons-material';
import { Autocomplete, Box, IconButton, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import ConfirmationModal from '../../ConfirmationModal';

interface ISavedFilterPicker {
  names: string[];
  value: string | null;
  onSelect: (name: string) => void;
  onDelete: (name: string) => void;
}

export default function SavedFilterPicker({ names, value, onSelect, onDelete }: ISavedFilterPicker) {
  const [deleteName, setDeleteName] = useState<string | null>(null);

  const onConfirmDelete = () => {
    if (!deleteName) return;

    onDelete(deleteName);
    setDeleteName(null);
  };

  const handleDelete = (event: React.MouseEvent, name: string) => {
    event.stopPropagation();
    setDeleteName(name);
  };

  return (
    <>
      <Autocomplete<string>
        options={names}
        value={value}
        onChange={(_, value) => onSelect(value || '')}
        renderInput={(params) => (
          <TextField {...params} label="Filter Name" />
        )}
        renderOption={(props, option) => {
          const isDefault = option === '';
          return <Box component='li' {...props}>
            <Typography>{isDefault ? 'Default' : option}</Typography>
            {!isDefault &&
              <IconButton sx={{ justifySelf: 'end' }} onClick={(event) => handleDelete(event, option)}>
                <Delete />
              </IconButton>
            }
          </Box>;
        }}
        slotProps={{
          listbox: {
            sx: { '& .MuiAutocomplete-option': { justifyContent: 'space-between' } }
          }
        }}
        sx={{
          pb: 4,
        }}
      />
      <ConfirmationModal
        isOpen={!!deleteName}
        text={`Are you sure you want to delete the ${deleteName} filter? This is cannot be undone.`}
        onCancel={() => setDeleteName(null)}
        onConfirm={onConfirmDelete}
      />
    </>
  );
}